var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"background"}},[_c('SubMenuHeader',{attrs:{"title":_vm.$t('drillDownScreen.pageTitle')},on:{"onGoBack":_vm.back,"showVideo":function($event){return _vm.$emit('showVideo')}}}),_c('div',{staticClass:"container under-header"},[_c('DrillDown',{staticClass:"pt-5"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }